import { apiEndpoints } from './api-endpoints';

export const environment = {
  production: false,
  local: false,
  publicApiPrefix: '/publicapi/v1',
  privateApiPrefix: '/api/v1',
  apiPrefix: '/api/v1',
  ...apiEndpoints,
};
